export class AlertItemQualifier {
    readonly id: string;
    readonly name: string;
    readonly type: string;

    constructor(options: {
        id: string;
        name: string;
        type: string;
    }) {
        this.id = options.id;
        this.name = options.name;
        this.type = options.type;
    }
}
